import React, { Component } from 'react';
import ChartistGraph from './base-chart';
import Header from '../graph/header';
import getDefaultOptions from '../../get-chart-default-options';
import { getResolution, hasHourlyResolution, dayDiffResolution } from '../../get-resolution';

class LikesChart extends Component {
  constructor(props, context) {
    super(props, context);
    var { analytics } = this.props;
    this.state = { resolution: analytics.resolution, newData: true };
  }
  onResolutionChange(resolution) {
    this.state.resolution = resolution;
    this.state.newData = false;
    this.props.resolutionChange(resolution, 'likes');
  }
  render() {
    var { analytics, loading } = this.props;
    var fromDay = analytics.get('from_day');
    var toDay = analytics.get('to_day');
    var likes = analytics.get('likes');
    var dislikes = analytics.get('dislikes');
    var hasHourly = hasHourlyResolution(fromDay, toDay);
    var dayDiff = dayDiffResolution(fromDay, toDay);
    var likePoints = likes.points || [];
    var dislikePoints = dislikes.points || [];
    let maxLikeValue = Math.max.apply(
      Math,
      likePoints.map(function(o) {
        return o.y;
      })
    );
    let maxDislikeValue = Math.max.apply(
      Math,
      dislikePoints.map(function(o) {
        return o.y;
      })
    );
    dislikePoints = dislikePoints.map(point => {
      if (Object.getOwnPropertyNames(point).length < 1) {
        point = undefined;
      }
      return point;
    });
    this.state.newData = true;
    var data = {
      series:
        maxLikeValue >= maxDislikeValue
          ? [
              {
                chartType: 'likes',
                data: likePoints,
                type: 'likes',
                className: 'ct-series-likes'
              },
              {
                chartType: 'likes',
                data: dislikePoints,
                type: 'dislikes',
                className: 'ct-series-dislikes'
              }
            ]
          : [
              {
                chartType: 'likes',
                data: dislikePoints,
                type: 'dislikes',
                className: 'ct-series-dislikes'
              },
              {
                chartType: 'likes',
                data: likePoints,
                type: 'likes',
                className: 'ct-series-likes'
              }
            ]
    };
    var numberOfpoints = likePoints.length;
    let resolution = this.state.newData ? likes.resolution : this.state.resolution;
    resolution = getResolution(toDay, fromDay, resolution);
    var options = getDefaultOptions(
      'likes',
      numberOfpoints,
      resolution,
      maxLikeValue >= maxDislikeValue ? ['Likes', 'Dislikes'] : ['Dislikes', 'Likes'],
      maxLikeValue >= maxDislikeValue ? ['likes', 'dislikes'] : ['dislikes', 'likes'],
      true
    );
    var aspectRatio = 'ct-octave likes-chart';

    return (
      <div>
        <Header
          resolutionChange={this.onResolutionChange.bind(this)}
          hasHourly={hasHourly}
          dayDiff={dayDiff}
          resolution={resolution}
          name="likes"
          title="Likes"
        />
        <ChartistGraph
          className={aspectRatio}
          data={data}
          options={options}
          type="Line"
          loading={loading}
        />
      </div>
    );
  }
}
LikesChart.displayName = 'LikesChart';

// LikesChart.propTypes = {
//   analytics: PropTypes.instanceOf(AnalyticsModel).isRequired,
//   spotId: PropTypes.string.isRequired,
//   resolutionChange: PropTypes.func.isRequired
// };

// LikesChart.contextTypes = {
//   executeAction: PropTypes.func.isRequired,
// };

export default LikesChart;
